module.exports = __webpack_public_path__ + "img/pc_intr.8a00dc2.webp";